// Standard DOOH aspect ratios used across the application
export const KNOWN_ASPECT_RATIOS = [
  // Dominant (majority coverage)
  { name: '9:16', decimal: 0.56 },
  { name: '16:9', decimal: 1.78 },

  // Core standard formats
  { name: '1:1', decimal: 1.0 },
  { name: '4:3', decimal: 1.33 },
  { name: '3:2', decimal: 1.5 },
  { name: '16:10', decimal: 1.6 },
  { name: '2:3', decimal: 0.67 },

  // DOOH / wide screens
  { name: '2:1', decimal: 2.0 },
  { name: '3:1', decimal: 3.0 },
  { name: '21:9', decimal: 2.33 },
  { name: '32:9', decimal: 3.56 },
  { name: '19.5:9', decimal: 2.17 },
  { name: '20:9', decimal: 2.22 },
];
